import { useState } from 'react';

export const useConfirm = ({ onConfirm, onReject }: { onConfirm: () => void; onReject?: () => void }) => {
  const [open, setOpen] = useState(false);

  return {
    handleCancel: () => {
      onReject?.();
      setOpen(false);
    },
    handleClickOpen: () => {
      setOpen(true);
    },
    handleClose: () => {
      setOpen(false);
    },
    handleConfirm: () => {
      onConfirm();
      setOpen(false);
    },
    open,
  };
};
